import { Route } from '@angular/router';
import { AuthGuard, LoginCallbackComponent, LoginShellComponent } from '@iot-platform/auth';
import { NavigationRoutes } from '@iot-platform/models/common';
import { provideNteApplicationState } from './app.config';

export const APP_ROUTES: Route[] = [
  {
    path: NavigationRoutes.LOGIN,
    children: [
      {
        path: '',
        component: LoginShellComponent
      },
      {
        path: NavigationRoutes.LOGIN_CALLBACK,
        component: LoginCallbackComponent
      }
    ],
    providers: [provideNteApplicationState()]
  },
  {
    path: '',
    loadChildren: () => import('@iot-platform/nte/feature/app-shell').then((m) => m.AppShellRoutes),
    canActivate: [AuthGuard],
    providers: [provideNteApplicationState()]
  },
  { path: NavigationRoutes.HOME, redirectTo: `/${NavigationRoutes.DEVICES}` },
  { path: '', redirectTo: `/${NavigationRoutes.HOME}`, pathMatch: 'full' },
  { path: '**', redirectTo: `/${NavigationRoutes.HOME}` }
];
